import {
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  makeArgumentsPrivate,
  pickArgs,
} from '../../../../utils/spds/metadata';
import Super from '../../core/base.gjs';
import VariableLayout from '../../layout/variable.gjs';
import styles from './content-container.module.scss';

export const GRID_DEFAULT = false;

const METADATA = {
  component: 'Spds::Container::Accordion::ContentContainer',
  description: 'Collapsible content area for Accordion component',
  meta: {
    ...makeArgumentsPrivate(pickArgs(COMPONENT_STATE_ARGS, ['animated', 'open'])).meta,
    ...pickArgs(CONTAINER_ARGS, ['grid', 'reverse']).meta,
    ...ALL_LAYOUT_ARGS.meta,
    column: {
      ...CONTAINER_ARGS.meta.column,
      defaultValue: true,
    },
  },
  name: 'Accordion Content Container',
};

export default class SpdsContainerAccordionContentContainer extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-container-accordion-content-container';
  classesToMapToArgs = ['animated', 'open'];
  styles = styles;

  get hidden() {
    return `${!this.args.open}`;
  }

  get innerId() {
    return this.composeSubcomponentId('inner');
  }

  constructor() {
    super(...arguments);

    this.arguments = this.composeArguments(METADATA);
  }

  <template>
    <VariableLayout
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @column={{@column}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{@flexWrap}}
      @gap={{@gap}}
      @grid={{@grid}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @id={{this.innerId}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @reverse={{@reverse}}
      @row={{@row}}
      @rows={{@rows}}
      class={{this.classes}}
      data-test-spds-container-accordion-content-container
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-hidden={{this.hidden}}
      aria-labelledby={{@triggerId}}
      ...attributes
    >
      {{yield}}
    </VariableLayout>
  </template>
}

export const ACCORDION_CONTENT_CONTAINER_METADATA = SpdsContainerAccordionContentContainer.metadata;
